export const ImageType = {
	UPLOAD:    'upload',
	SNAPSHOT:  'snapshot',
	GENERATED: 'generated',
};
